import Hiraku from 'hiraku/js/hiraku';
import Hiraku01 from 'hiraku/js/hiraku';

//hiraku
$(function(){
    new Hiraku('.js-offcanvas', {
        btn: ".js-offcanvas-btn",
        closeBtn:'.sp-menu-close-menu',
        fixedHeader: ".js-offcanvas-btn",
        direction: 'right',
        width:'85%'
    });
    new Hiraku('.js-search-wrap', {
        btn: ".header__search-btn",
        closeBtn:'.sp-menu-close-menu',
        // fixedHeader: ".js-fixed-header",
        direction: 'right',
        width:'90%'
    });

});



//z-indexをボタンクリック時に変更する
$('.js-offcanvas-btn:not(.close-btn)').click(function() {
    $('.js-offcanvas').css('z-index','10003');
    $('.js-search-wrap').css('z-index','10002');

});
$('.header__search-btn').click(function() {
    $('.js-search-wrap').css('z-index','10003');
    $('.js-offcanvas').css('z-index','10002');
});

